export const iconFontAwesomeDesignDrawPolygon = (
	<i className="fa-solid fa-draw-polygon"></i>
);
